export  const Crm = ({ size = 22, ...props }) => (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6953 5.03125C21.3125 9.67969 20.9609 15.8516 20.9609 16.5938C20.9609 18.7812 19.0469 20.5 16.7031 20.5H5.25781C2.91406 20.5 1 18.7812 1 16.5938C1 15.8125 0.609375 9.71875 8.22656 5.03125L6.07812 1.86719C5.92188 1.59375 5.96094 1.24219 6.11719 0.96875C6.27344 0.695312 6.58594 0.5 6.89844 0.5H15.0234C15.375 0.5 15.6484 0.695312 15.8438 0.96875C16 1.24219 16.0391 1.59375 15.8828 1.86719L13.6953 5.03125ZM13.2656 2.375H8.69531L10.1797 4.5625H11.7422L13.2656 2.375ZM19.0859 16.5938C19.125 13.4297 17.7969 9.75781 12.4453 6.4375H9.51562C4.125 9.75781 2.83594 13.4297 2.875 16.5938C2.875 17.7266 3.92969 18.625 5.25781 18.625H16.7031C18.0312 18.625 19.0859 17.7266 19.0859 16.5938Z"
        fill="currentColor"
      />
    </svg>
  );

export  const Staff = ({ size = 22, ...props }) => (
    <svg
      width="25"
      height="21"
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4609 13C10.2344 13 8.39844 11.2031 8.39844 8.9375C8.39844 6.71094 10.2344 4.875 12.4609 4.875C14.7266 4.875 16.5234 6.71094 16.5234 8.9375C16.5234 11.2031 14.7266 13 12.4609 13ZM12.4609 6.75C11.2891 6.75 10.2734 7.76562 10.2734 8.9375C10.2734 10.1484 11.2891 11.125 12.4609 11.125C13.6719 11.125 14.6484 10.1484 14.6484 8.9375C14.6484 7.76562 13.6719 6.75 12.4609 6.75ZM20 6.75C18.2422 6.75 16.875 5.38281 16.875 3.625C16.875 1.90625 18.2422 0.5 20 0.5C21.7188 0.5 23.125 1.90625 23.125 3.625C23.125 5.38281 21.7188 6.75 20 6.75ZM14.4141 14.25C17.5 14.25 20 16.5938 20 19.4844C20 20.0703 19.4922 20.5 18.8672 20.5H6.09375C5.46875 20.5 5 20.0703 5 19.4844C5 16.5938 7.46094 14.25 10.5469 14.25H14.4141ZM6.95312 18.625H18.0078C17.5781 17.2188 16.1328 16.125 14.4141 16.125H10.5469C8.82812 16.125 7.38281 17.2188 6.95312 18.625ZM21.5234 8C23.4375 8 25 9.64062 25 11.6719C25 12.0625 24.6875 12.375 24.2969 12.375H16.4844C17.3047 11.4766 17.7734 10.2656 17.7734 8.9375C17.7734 8.74219 17.7344 8.54688 17.7344 8.35156C18.1641 8.15625 18.6328 8 19.1406 8H21.5234ZM7.14844 8.9375C7.14844 10.2656 7.65625 11.4766 8.47656 12.375H0.664062C0.273438 12.375 0 12.0625 0 11.6719C0 9.64062 1.52344 8 3.4375 8H5.82031C6.32812 8 6.79688 8.11719 7.22656 8.35156C7.1875 8.54688 7.14844 8.74219 7.14844 8.9375ZM5 6.75C3.24219 6.75 1.875 5.38281 1.875 3.625C1.875 1.90625 3.24219 0.5 5 0.5C6.71875 0.5 8.125 1.90625 8.125 3.625C8.125 5.38281 6.71875 6.75 5 6.75Z"
        fill="currentColor"
      />
    </svg>
  );

export  const Bank = ({ size = 22, ...props }) => (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0625 18.5859C19.5703 18.5859 20 18.9766 20 19.5234C20 20.0312 19.5703 20.4609 19.0625 20.4609H0.9375C0.390625 20.4609 0 20.0312 0 19.5234C0 18.9766 0.390625 18.5859 0.9375 18.5859H19.0625ZM17.8125 17.3359H2.1875C1.64062 17.3359 1.25 16.9062 1.25 16.3984C1.25 15.8516 1.64062 15.4609 2.1875 15.4609H17.8125C18.3203 15.4609 18.75 15.8516 18.75 16.3984C18.75 16.9062 18.3203 17.3359 17.8125 17.3359ZM19.4141 4.25C19.7656 4.40625 20 4.75781 20 5.14844V7.64844C20 8.15625 19.5703 8.58594 19.0625 8.58594H17.5V14.2109H15.625V8.58594H13.125V14.2109H11.25V8.58594H8.75V14.2109H6.875V8.58594H4.375V14.2109H2.5V8.58594H0.9375C0.390625 8.58594 0 8.15625 0 7.64844V5.14844C0 4.75781 0.195312 4.40625 0.546875 4.25L9.60938 0.5C9.84375 0.421875 10.1172 0.421875 10.3516 0.5L19.4141 4.25ZM18.125 6.71094V5.77344L10 2.41406L1.875 5.77344V6.71094H8.20312C8.16406 6.51562 8.125 6.28125 8.125 6.08594C8.125 5.03125 8.94531 4.21094 10 4.21094C11.0156 4.21094 11.875 5.03125 11.875 6.08594C11.875 6.28125 11.7969 6.51562 11.7578 6.71094H18.125Z"
        fill="currentColor"
      />
    </svg>
  );

export  const Affiliate = ({ size = 22, ...props }) => (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0469 12.4922C15.2891 13.0781 17.75 15.8906 17.75 19.25C17.75 19.9531 17.1641 20.5 16.5 20.5H1.5C0.796875 20.5 0.25 19.9531 0.25 19.25C0.25 15.8906 2.67188 13.0781 5.91406 12.4922L7.67188 16.0469L8.375 13.625L7.125 11.75H10.875L9.625 13.625L10.2891 16.0469L12.0469 12.4922ZM2.125 18.625H6.89062L4.9375 14.7578C3.41406 15.5 2.35938 16.9453 2.125 18.625ZM11.0703 18.625H15.8359C15.6016 16.9453 14.5469 15.5 13.0234 14.7578L11.0703 18.625ZM9 10.5C6.22656 10.5 4 8.27344 4 5.5C4 2.76562 6.22656 0.5 9 0.5C11.7344 0.5 14 2.76562 14 5.5C14 8.27344 11.7344 10.5 9 10.5ZM9 2.375C7.24219 2.375 5.875 3.78125 5.875 5.5C5.875 7.25781 7.24219 8.625 9 8.625C10.7188 8.625 12.125 7.25781 12.125 5.5C12.125 3.78125 10.7188 2.375 9 2.375Z"
        fill="currentColor"
      />
    </svg>
  );

export  const Report = ({ size = 22, ...props }) => (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 11.4141C5.27344 11.8047 4.6875 11.8047 4.33594 11.4141C3.94531 11.0625 3.94531 10.4766 4.33594 10.125L7.46094 7C7.8125 6.60938 8.39844 6.60938 8.75 7L11.875 10.0859L17.1484 4.8125C17.5 4.42188 18.0859 4.42188 18.4375 4.8125C18.8281 5.16406 18.8281 5.75 18.4375 6.10156L12.5 12.0391C12.3438 12.2344 12.1094 12.3125 11.875 12.3125C11.6016 12.3125 11.3672 12.2344 11.2109 12.0391L8.125 8.95312L5.625 11.4141ZM19.0625 16.375C19.5703 16.375 20 16.8047 20 17.3125C20 17.8594 19.5703 18.25 19.0625 18.25H1.25C0.546875 18.25 0 17.7031 0 17V1.6875C0 1.17969 0.390625 0.75 0.9375 0.75C1.44531 0.75 1.875 1.17969 1.875 1.6875V16.375H19.0625Z"
        fill="currentColor"
      />
    </svg>
  );

export  const Dashboard = ({ size = 22, ...props }) => (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.875 0.5C7.89062 0.5 8.75 1.35938 8.75 2.375V7.375C8.75 8.42969 7.89062 9.25 6.875 9.25H1.875C0.820312 9.25 0 8.42969 0 7.375V2.375C0 1.35938 0.820312 0.5 1.875 0.5H6.875ZM18.125 11.75C19.1406 11.75 20 12.6094 20 13.625V18.625C20 19.6797 19.1406 20.5 18.125 20.5H13.125C12.0703 20.5 11.25 19.6797 11.25 18.625V13.625C11.25 12.6094 12.0703 11.75 13.125 11.75H18.125ZM18.125 0.5C19.1406 0.5 20 1.35938 20 2.375V7.375C20 8.42969 19.1406 9.25 18.125 9.25H13.125C12.0703 9.25 11.25 8.42969 11.25 7.375V2.375C11.25 1.35938 12.0703 0.5 13.125 0.5H18.125ZM6.875 11.75C7.89062 11.75 8.75 12.6094 8.75 13.625V18.625C8.75 19.6797 7.89062 20.5 6.875 20.5H1.875C0.820312 20.5 0 19.6797 0 18.625V13.625C0 12.6094 0.820312 11.75 1.875 11.75H6.875Z"
        fill="currentColor"
      />
    </svg>
  );

export  const Logout = ({ size = 22, ...props }) => (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 18.25C1.64062 18.25 0 16.6094 0 14.5V4.5C0 2.42969 1.64062 0.75 3.75 0.75H6.25C6.91406 0.75 7.5 1.33594 7.5 2C7.5 2.70312 6.91406 3.25 6.25 3.25H3.75C3.04688 3.25 2.5 3.83594 2.5 4.5V14.5C2.5 15.2031 3.04688 15.75 3.75 15.75H6.25C6.91406 15.75 7.5 16.3359 7.5 17C7.5 17.7031 6.91406 18.25 6.25 18.25H3.75ZM19.6875 8.83594C20.0781 9.1875 20.0781 9.85156 19.6875 10.2031L14.0625 15.5156C13.7891 15.7891 13.3984 15.8281 13.0469 15.7109C12.6953 15.5547 12.5 15.2031 12.5 14.8125V12H7.5C6.79688 12 6.25 11.4531 6.25 10.75V8.25C6.25 7.58594 6.79688 7 7.5 7H12.5V4.1875C12.5 3.83594 12.6953 3.48438 13.0469 3.32812C13.3984 3.21094 13.7891 3.25 14.0625 3.52344L19.6875 8.83594Z"
        fill="currentColor"
      />
    </svg>
  );

 export const Finance = ({ size = 22, ...props }) => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.57812C11.75 5.57812 15.5 6.71094 15.5 8.9375V17.0625C15.5 19.3281 11.7109 20.5 8 20.5C4.25 20.5 0.5 19.3281 0.5 17.0625V8.9375C0.5 6.71094 4.25 5.57812 8 5.57812ZM13.625 17.0625V15.3828C12.1797 16.0859 10.0703 16.4375 8 16.4375C5.89062 16.4375 3.78125 16.0859 2.375 15.3828V17.0625C2.375 17.4922 4.28906 18.625 8 18.625C11.6719 18.625 13.625 17.4922 13.625 17.0625ZM13.625 13V11.3203C12.1797 12.0234 10.0703 12.375 8 12.375C5.89062 12.375 3.78125 12.0234 2.375 11.3203V13C2.375 13.4297 4.28906 14.5625 8 14.5625C11.6719 14.5625 13.625 13.4297 13.625 13ZM8 10.5C11.6719 10.5 13.625 9.36719 13.625 8.9375C13.625 8.54688 11.6719 7.375 8 7.375C4.28906 7.375 2.375 8.54688 2.375 8.9375C2.375 9.36719 4.28906 10.5 8 10.5ZM13 0.5C16.7109 0.5 20.5 1.71094 20.5 3.9375V12.0625C20.5 14.0547 17.6094 14.875 17.375 14.875C16.8281 14.875 16.3984 14.4453 16.3984 13.9375C16.3984 13.5469 16.6719 13.1953 17.0625 13.0391C18.3516 12.6094 18.625 12.1406 18.625 12.0625V10.3828C18.4688 10.4219 17.6875 10.8516 17.3359 10.8516C16.7891 10.8516 16.3984 10.4219 16.3984 9.91406C16.3984 9.48438 16.6328 9.13281 17.0234 9.01562C18.3125 8.58594 18.625 8.07812 18.625 8V6.32031C18.4297 6.39844 17.6875 6.75 17.375 6.75C16.8281 6.75 16.3984 6.32031 16.3984 5.8125C16.3984 5.42188 16.6719 5.07031 17.0625 4.91406C18.3516 4.48438 18.625 4.01562 18.625 3.9375C18.625 3.54688 16.6719 2.375 13 2.375C7.88281 2.375 7.60938 4.13281 6.71094 4.13281C6.08594 4.13281 5.77344 3.58594 5.77344 3.19531C5.77344 2.0625 8.50781 0.5 13 0.5Z"
        fill="currentColor"
      />
    </svg>
  );